import { useEffect, useState } from 'react'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import IconButton from '@mui/material/IconButton'
import Toolbar from '@mui/material/Toolbar'
import BadgeIcon from '@mui/icons-material/Badge'
import CloseIcon from '@mui/icons-material/Close'
import { Outlet, useLocation } from 'react-router'
import BottomNavBar from '../BottomNavBar'
import HelpDialog from '../HelpDialog'
import NotificationBell from '../NotificationBell'
import ProfileCard from '../ProfileCard'
import { useSessionStore } from '../../state'

const NavigationShell = () => {
  const user = useSessionStore(state => state.user)
  const [cardOpen, setCardOpen] = useState(false)
  const location = useLocation()

  // Close the profile dialog whenever the route changes
  useEffect(() => {
    setCardOpen(false)
  }, [location.pathname])

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {user && (
        <AppBar position='sticky' color='default' elevation={1}>
          <Toolbar sx={{ justifyContent: 'flex-end', gap: 1 }}>
            <IconButton
              color='inherit'
              onClick={() => setCardOpen(true)}
              aria-label='profile card'
            >
              <BadgeIcon />
            </IconButton>
            <HelpDialog />
            <NotificationBell userId={user.uid} />
          </Toolbar>
        </AppBar>
      )}
      <Box
        component='main'
        sx={{ flex: 1, pb: 'calc(56px + env(safe-area-inset-bottom))' }}
      >
        <Outlet />
      </Box>
      <BottomNavBar />

      <Dialog open={cardOpen} onClose={() => setCardOpen(false)} fullScreen>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', pt: 1, pr: 1 }}>
          <IconButton
            onClick={() => setCardOpen(false)}
            aria-label='close'
            size='small'
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <DialogContent sx={{ pt: 0 }}>
          <ProfileCard />
        </DialogContent>
      </Dialog>
    </Box>
  )
}

export default NavigationShell
